
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const state = {
  globalListFilters: {
    includedBlindedUser: false
  },
  activeTab: {
    system: 'Actions',
    'system-sql': 'Query',
    partner: 'Informations',
    managing: 'Informations',
    establishment: 'Informations',
    group: 'Informations',
    user: 'Informations',
  }
}

const mutations = {
  toggleBlindedUserFilter(state) {
    state.globalListFilters.includedBlindedUser = !state.globalListFilters.includedBlindedUser;
  },
  setActiveTab(state, obj) {
    state.activeTab[obj.type] = obj.name;
  }
}

const actions = {
}


const getters = {
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/store/store.js